export default __webpack_public_path__ + "static/carousel_image_1_lena-a65accb93608220ca1b78fae0336ab9e.jpeg";